module.exports = __webpack_public_path__ + "img/unavailable.c2a4b857.png";